const localePtBr = {
    moduleType: "locale", name: "pt-BR",
    dictionary: {
        Autoscale: "Escala autom\xe1tica",
        "Box Select": "Sele\xe7\xe3o retangular",
        "Click to enter Colorscale title": "Clique para editar o t\xedtulo da escala de cor",
        "Click to enter Component A title": "Clique para editar o t\xedtulo do Componente A",
        "Click to enter Component B title": "Clique para editar o t\xedtulo do Componente B",
        "Click to enter Component C title": "Clique para editar o t\xedtulo do Componente C",
        "Click to enter Plot title": "Clique para editar o t\xedtulo do Gr\xe1fico",
        "Click to enter X axis title": "Clique para editar o t\xedtulo do eixo X",
        "Click to enter Y axis title": "Clique para editar o t\xedtulo do eixo Y",
        "Click to enter radial axis title": "Clique para editar o t\xedtulo do eixo radial",
        "Compare data on hover": "Comparar dados ao pairar",
        "Double-click on legend to isolate one trace": "Duplo clique na legenda para isolar uma s\xe9rie",
        "Double-click to zoom back out": "Duplo clique para reverter zoom",
        "Download plot as a png": "Fazer download do gr\xe1fico como imagem (png)",
        "Edit in Chart Studio": "Editar no Chart Studio",
        "IE only supports svg.  Changing format to svg.": "IE suporta apenas svg. Alterando formato para svg",
        "Lasso Select": "Sele\xe7\xe3o de la\xe7o",
        "Orbital rotation": "Rota\xe7\xe3o orbital",
        Pan: "Mover",
        "Produced with Plotly": "Criado com o Plotly",
        Reset: "Restaurar",
        "Reset axes": "Restaurar eixos",
        "Reset camera to default": "Restaurar c\xe2mera para padr\xe3o",
        "Reset camera to last save": "Restaurar c\xe2mera para \xfaltima salva",
        "Reset view": "Restaurar vis\xe3o",
        "Reset views": "Restaurar vis\xf5es",
        "Show closest data on hover": "Exibir dado mais pr\xf3ximo ao pairar",
        "Snapshot succeeded": "Captura instant\xe2nea completa",
        "Sorry, there was a problem downloading your snapshot!": "Desculpe, houve um problema no download de sua captura instant\xe2nea!",
        "Taking snapshot - this may take a few seconds": "Efetuando captura instant\xe2nea - isso pode levar alguns instantes",
        "Toggle Spike Lines": "Habilitar/desabilitar triangula\xe7\xe3o de linhas",
        "Toggle show closest data on hover": "Habilitar/desabilitar exibi\xe7\xe3o de dado mais pr\xf3ximo ao pairar",
        "Turntable rotation": "Rota\xe7\xe3o de mesa",
        Zoom: "Zoom",
        "Zoom in": "Ampliar zoom",
        "Zoom out": "Reduzir zoom",
        "close:": "fechamento:",
        "high:": "alta:",
        "incoming flow count:": "contagem de fluxo de entrada:",
        "kde:": "kde:",
        "lat:": "latitude:",
        "lon:": "longitude:",
        "low:": "baixa:",
        "lower fence:": "limite inferior:",
        "max:": "m\xe1ximo:",
        "mean \xb1 \u03c3:": "m\xe9dia \xb1 \u03c3:",
        "mean:": "m\xe9dia:",
        "median:": "mediana:",
        "min:": "m\xednimo:",
        "new text": "novo texto",
        "open:": "abertura:",
        "outgoing flow count:": "contagem de fluxo de sa\xedda:",
        "q1:": "q1:",
        "q3:": "q3:",
        "source:": "origem:",
        "target:": "destino:",
        trace: "s\xe9rie",
        "upper fence:": "limite superior:"
    },
    format: {
        days: ["Domingo", "Segunda-feira", "Ter\xe7a-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "S\xe1bado"],
        shortDays: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "S\xe1b"],
        months: ["Janeiro", "Fevereiro", "Mar\xe7o", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
        shortMonths: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
        date: "%d/%m/%Y",
        decimal: ",",
        thousands: "."
    }
};

const serieCampanhaColors = {
    'ts': '#ff4e2a',
    '100': '#377e94',
    '110': '#ff7f00',
    'ss': '#fe8f33',
    'sp': '#cc4c02'
};

const seriesToRemove = [];//['ss','sp'];

const serieCampanhaColors2 = {
    'Período chuvoso': '#306f82',
    'Período seco': '#7dbccf',
    'Sedimento': '#b35900',
    'Subsuperficial': '#b29966',
    'Superficial': '#665533'
};

const countingClassesColors = {
    'ACIMA': '#cc7777',
    'ABAIXO': '#6699cc',
    'DENTRO': '#66c2a4'//'#31a354'//'#66cc99'
};

const countingClassesColors2 = {
    '>LD': '#cc7777',
    '<LD': '#6699cc',
    'DETECTADO': '#66c2a4'//'#31a354'//'#66cc99'
};

const tipoLimiarColorsForPlot = {
    '20_true': '#08519c', //mMAD, azul
    '21_true': '#006d2c', //TIF, verde
    '22_true': '#3f007d', //p98, tons de roxo
    '23_true': '#6a51a3', //p95, tons de roxo
    '24_true': '#9e9ac8', //p90, tons de roxo
    '25_true': '#dadaeb', //p75, tons de roxo
    '30_true': '#cb181d', //Conama - Nível 1, sedimento, tons de vermelho
    '31_true': '#67000d', //Conama - Nível 2, sedimento, tons de vermelho
    '32_true': '#fcbba1', //Conama - Prevenção, solo, tons de vermelho
    '33_true': '#fb6a4a', //Conama - Investigação agrícola, solo, tons de vermelho
    '34_true': '#cb181d', //Conama - Investigação residencial, solo, tons de vermelho
    '35_true': '#67000d', //Conama - Investigação industrial, solo, tons de vermelho
    '36_true': '#A50F15', //Conama - Classe 2, água, vermelho (limiar inferior não é usado nos plots, logo só há uma cor para esse tipo de limiar)
    '40_true': '#747474', //limite de quantificação superior, cinza
    //'40_false': '#969696' //limite de quantificação inferior, cinza
    '40_false': '#747474' //limite de quantificação inferior, cinza
};

const statusOrder = ['ABAIXO', 'DENTRO', 'ACIMA'];

const statusOrderTranslated = ['<LD', 'DETECTADO', '>LD'];

const coresDagradeStatusRanges = {
    'ACIMA': ['#cc7777','#ff0000'],
    'ABAIXO': ['#6699cc','#37b6c1']
};

const coresCategoricalStatusRanges = {
    'ACIMA': ['#cc7777','#ed504a','#ff0000'],
    //'ABAIXO': ['#6699cc','#00a9f5','#00b2dd','#37b6c1']
    'ABAIXO': ['#1a5276','#366d89','#78b1bd','#b2e2e2']
};

const amostraTipos = [
    //{'ncode':10, 'code':'S','name':'SOLO'},
    {'ncode':20, 'code':'SC','name':'Sedimento de Corrente'},
    {'ncode':30, 'code':'AC','name':'Água Corrente'}
];

export {
    localePtBr,
    serieCampanhaColors,
    serieCampanhaColors2,
    countingClassesColors,
    countingClassesColors2,
    seriesToRemove,
    tipoLimiarColorsForPlot,
    statusOrder,
    statusOrderTranslated,
    amostraTipos,
    coresDagradeStatusRanges,
    coresCategoricalStatusRanges
};